export const CO_STATES = {
  0: { text: '草稿', type: 'info', desc: '信息尚未提交' },
  1: { text: '待审核', type: 'primary', desc: '资料审核中' },
  2: { text: '审核未通过', type: 'danger', desc: '请按反馈修改后重新提交' },
  3: { text: '审核未通过', type: 'danger', desc: '请重新认证' },
  4: { text: '已认证', type: 'success', desc: '可正常申请保函' }
}

export function formatDate (str) {
  if (!str) return '-'
  const d = new Date(str)
  if (Number.isNaN(d.getTime())) return str
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function formatMoney (val) {
  if (val === null || val === undefined || val === '') return '-'
  return Number(val).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
